export default {
  STL_FILES_REQUESTED: 'STL_FILES_REQUESTED',
  STL_FILES_UPLOADED: 'STL_FILES_UPLOADED',
  APPROVED: 'APPROVED',
} as const
